<div class="container mt-4">

  <div class="row mb-3">
    <div class="col-12">
      <h1>
        Smart Tag Finder Terms of Use
      </h1>
      <p class="text-muted">
        Effective Date: 1st September 2026
      </p>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">
      <p>
        Click on the links below to go straight to more information on each area:
      </p>
      <ul>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(A1)">
            Who we are
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(B1)">
            What this page is for
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(C1)">
            By using this page, you agree to these terms
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(D1)">
            What you can do on this page
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(E1)">
            Please use this page responsibly
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(F1)">
            No guarantee, and this isn't an emergency service
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(G1)">
            Your information
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(H1)">
            Content and ownership
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(I1)">
            Links to other services
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(J1)">
            Liability
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(K1)">
            Changes to this page and these terms
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(L1)">
            Which laws apply
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(M1)">
            Contact us
          </a>
        </li>
      </ul>

      <h4 #A1 id="A1" class="my-3">
        Who we are
      </h4>

      <p>
        This page is provided by Identicare Limited of Moorside, Monks Cross Drive, Huntington, York, YO32 9LB (company number 12960490), trading as 'identi' ("we", "us", "identi"). We are not the keeper of this pet - we provide the identi smart tag service that connects finders like you with the pet's keeper.
      </p>

      <h4 #B1 id="B1" class="my-3">
        What this page is for
      </h4>

      <p>
        You are seeing this page because you scanned an identi smart tag attached to a pet. This page shows the information the pet's keeper has chosen to make public, and gives you the option to help reunite the pet with its keeper.
      </p>

      <h4 #C1 id="C1" class="my-3">
        By using this page, you agree to these terms
      </h4>

      <p>
        These terms apply when you use this page. They explain how you may use the page and what you can expect from us. If you don't agree, please don't use the sharing options on this page; you can still choose to contact us directly instead (see below).
      </p>

      <h4 #D1 id="D1" class="my-3">
        What you can do on this page
      </h4>

      <ul>
        <li>view the information the keeper has chosen to make public about the pet;</li>
        <li>choose to share your current location and/or your contact details with the keeper, so they can arrange to collect their pet or get in touch with you; or</li>
        <li>choose not to share your details and instead contact identi directly using the details on this page, so that we can pass on a message to the keeper without disclosing your information to them.</li>
      </ul>

      <h4 #E1 id="E1" class="my-3">
        Please use this page responsibly
      </h4>

      <p>
        When using this page, you must not:
      </p>
      <ul>
        <li>provide false information, including a false location or false contact details;</li>
        <li>use this page, or any information shown on it, for any purpose other than helping to reunite the pet with its keeper;</li>
        <li>attempt to contact or locate the keeper other than through the options provided on this page or via identi; or</li>
        <li>use this page in any unlawful way, or in a way that could damage, disable or interfere with it or the systems behind it.</li>
      </ul>

      <h4 #F1 id="F1" class="my-3">
        No guarantee, and this isn't an emergency service
      </h4>

      <p>
        We provide this page to help reunite pets with their keepers. We cannot guarantee that the information provided by the keeper is complete, accurate or up to date, that the keeper will respond, or that the pet will be reunited with its keeper.
      </p>
      <p>
        If you choose to share your contact details with the keeper, any arrangements you make with them are between you and the keeper. identi is not responsible for those arrangements. If the animal appears injured, distressed or in immediate danger please contact a vet practice or animal welfare organisation. If the animal poses an immediate threat to people or other animals, contact the police or the relevant local authority.
      </p>

      <h4 #G1 id="G1" class="my-3">
        Your information
      </h4>

      <p>
        <strong>Age.</strong> By choosing to share your location or contact details on this page, you confirm that you are 18 years of age or over. If you are under 18, please ask a parent, guardian or another responsible adult to contact us.
      </p>
      <p>
        If you choose to share your location or contact details, we will use them only to help reunite the pet with its keeper. Full details of how we handle your information are set out in our <a [routerLink]="['/finder-privacy-policy']">Smart Tag Finder Privacy Notice</a>, which you should read before sharing any information.
      </p>

      <h4 #H1 id="H1" class="my-3">
        Content and ownership
      </h4>

      <p>
        The information and design of this page belong to us or the pet's keeper, as applicable. You may only use the information on this page to help reunite the pet with its keeper.
      </p>

      <h4 #I1 id="I1" class="my-3">
        Links to other services
      </h4>

      <p>
        This page may use third-party services such as mapping tools to help you share your location. Those services have their own terms and privacy policies, which are not provided by us and which we encourage you to review.
      </p>

      <h4 #J1 id="J1" class="my-3">
        Liability
      </h4>

      <p>
        We do not exclude or limit any liability that cannot legally be excluded or limited. Subject to that, we are not responsible for any loss or damage arising from your use of this page or your interaction with the pet's keeper, except where that loss or damage results from our failure to use reasonable care and skill.
      </p>

      <h4 #K1 id="K1" class="my-3">
        Changes to this page and these terms
      </h4>

      <p>
        We may update these terms from time to time to reflect changes to the service or the law. The latest version will be available on this page.
      </p>

      <h4 #L1 id="L1" class="my-3">
        Which laws apply
      </h4>

      <p>
        These terms are governed by English law. If you live in Scotland or Northern Ireland, you may also bring proceedings in the courts of Scotland or Northern Ireland respectively.
      </p>

      <h4 #M1 id="M1" class="my-3">
        Contact us
      </h4>

      <p>
        If you have any questions, or want to report a concern about this page, please contact us at <a href="mailto:hello@identicare.pet">hello&#64;identicare.pet</a> or 0330 9128077.
      </p>

    </div>
  </div>

</div>
